import { defaultAccessLevels, generateKeyNamesByAccessLevel } from '@nu-art/permissions-shared';
export const DomainNamespace_AdvisorUI = 'Advisor UI';
export const AdvisorUIPermissionKeys = generateKeyNamesByAccessLevel(DomainNamespace_AdvisorUI, defaultAccessLevels);
//# sourceMappingURL=advisor-ui.js.map